/** ISO 639-1 → fichier drapeau plat (public/flags). */
const FLAG_FILE_BY_LANG: Record<string, string> = {
  fr: 'fr',
  en: 'gb',
  es: 'es',
  de: 'de',
  pt: 'pt',
  it: 'it',
  nl: 'nl',
};

const KNOWN_FLAG_FILES = new Set(Object.values(FLAG_FILE_BY_LANG));

export const getLanguageFlagSrc = (lang: string): string => {
  const normalized = (lang || '').toLowerCase().split('-')[0];
  const file = FLAG_FILE_BY_LANG[normalized];
  const publicUrl = process.env.PUBLIC_URL || '';
  if (file) {
    return `${publicUrl}/flags/${file}.svg`;
  }
  if (KNOWN_FLAG_FILES.has(normalized)) {
    return `${publicUrl}/flags/${normalized}.svg`;
  }
  return `${publicUrl}/flags/unknown.svg`;
};

export type LanguageLabelKey =
  | 'languageSelector.french'
  | 'languageSelector.english'
  | 'languageSelector.portuguese';

const LANGUAGE_LABEL_KEYS: Partial<Record<string, LanguageLabelKey>> = {
  fr: 'languageSelector.french',
  en: 'languageSelector.english',
  pt: 'languageSelector.portuguese',
};

export const getLanguageAriaLabel = (
  lang: string,
  t: (key: string) => string
): string => {
  const normalized = (lang || '').toLowerCase().split('-')[0];
  const labelKey = LANGUAGE_LABEL_KEYS[normalized];
  if (labelKey) {
    return t(labelKey);
  }
  return normalized.toUpperCase();
};
